import React from 'react';
import {TextFieldProps, TextField as MuiTextField} from '@mui/material';

const TextField: React.FC<TextFieldProps> = (props) => {

    return <MuiTextField variant="outlined" {...props} />
}

export default TextField;